import React, { Component, lazy } from "react";
// import { connect } from "react-redux";

// import { setInitialFilterRefineValues } from "../../../actions/dashboardAction";

const LoadableDashboardPage = lazy(() => import("../Dashboard/DashboardPage"));

class CollectionsPostsPage extends Component {
    state = {};

    componentDidMount() {
        // let filterRefineFilter = {
        //     sentiment: ["all"],
        //     sentimentType: "all",
        //     media: "all",
        //     postType: "all",
        //     sampling: "100",
        //     channel: "all",
        //     exclusion: "yes",
        //     reviewStatus: "opened",
        // };
        // this.props.setInitialFilterRefineValues(filterRefineFilter);
    }

    render() {
        return <LoadableDashboardPage {...this.props} dashboardPageType="collection" />;
    }
}

export default CollectionsPostsPage;
